import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/gramps-graphql/gramps/docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`At its core, a GrAMPS data source is simply an organizational structure to make GraphQL servers easier to build out of modular components.`}</p>
      <p>{`By following the GrAMPS structure, data sources become more manageable, testable, and shareable. Different teams can own and maintain data sources that are all composed together and exposed through a single GraphQL gateway.`}</p>
      <p>{`Developers can even get full GraphQL schemas for third-party services simply by installing that service’s data source.`}</p>
    </PageDescription>
    <h2 {...{
      "id": "the-anatomy-of-a-data-source"
    }}>{`The Anatomy of a Data Source`}</h2>
    <p>{`Every GraphQL data source exports a `}<strong parentName="p">{`GrAMPS object`}</strong>{` which defines the following properties:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`namespace`}</inlineCode>{` — a unique name for the data source`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`context`}</inlineCode>{` — an object to be used as the context for the resolvers`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`typeDefs`}</inlineCode>{` — type definitions for a GraphQL schema
(see `}<a parentName="p" {...{
            "href": "http://graphql.org/learn/schema/"
          }}>{`the GraphQL docs on schemas for more info`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`resolvers`}</inlineCode>{` — an object containing resolver functions
(see `}<a parentName="p" {...{
            "href": "http://graphql.org/learn/execution/"
          }}>{`the GraphQL docs on execution for more info`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`mocks`}</inlineCode>{` — mock resolver functions
(see `}<a parentName="p" {...{
            "href": "https://www.apollographql.com/docs/graphql-tools/mocking.html"
          }}>{`the Apollo docs on mocking for more info`}</a>{`)`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "why-follow-the-gramps-standard"
    }}>{`Why Follow the GrAMPS Standard?`}</h2>
    <ul>
      <li parentName="ul">{`Consistency, maintainability, and simplicity: data sources follow a
predictable, well-documented format.`}</li>
      <li parentName="ul">{`Centralized data, distributed maintenance (one endpoint, many repos)`}</li>
      <li parentName="ul">{`Reusability: plug together community GrAMPS data sources with your own to
build complex applications faster`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      